import { IBaseAction } from '../../../interfaces/IBaseAction'
export enum Keys {
    LOAD = 'react/common/birthday/LOAD',
    LOAD_PENDING = 'react/common/birthday/LOAD_PENDING',
    LOAD_FULFILLED = 'react/common/birthday/LOAD_FULFILLED',
    LOAD_REJECTED = 'react/common/birthday/LOAD_REJECTED',
        
    OTHER_ACTION = 'react/common/birthday/__any_other_action__',
}

export type Types = IBaseAction<Keys>;